export const SCENARIO_BUYING_POWER_HISTORY_MOCKUP_DATA = {
  bcId: "e2ef4af3-2a1f-4a0e-94d7-0aa7ffdff18c",
  opportunity: "",
  borrowCapacityList: {},
  maxBuyingPowerList: {},
};
